/**
 * A Google Fonts stylesheet for a page that is server-rendered and then hydrated.
 *
 * Not a plain `<link>`: on www.stippl.io, Cloudflare Fonts (a zone setting) rewrites every
 * `<link rel="stylesheet" href="https://fonts.googleapis.com/css2?…">` in the HTML into an inline
 * `<style>` of @font-face rules served from /cf-fonts/. A `<link>` element in the React tree then
 * meets a `<style>` in the DOM, hydration fails (React #418, then #423) and the whole page is
 * re-rendered on the client. React does not hydrate what is inside `dangerouslySetInnerHTML`, so
 * whatever Cloudflare makes of the link is left alone. PR previews skip Cloudflare and never showed it.
 *
 * One link per family: Cloudflare Fonts inlines only the first `family=` of a URL and drops the rest
 * (2026-11-03: Montserrat, Questrial and Ode's Libre Bodoni and Sacramento never loaded on www).
 */
export const perFamily = (href: string): string[] => {
	const [base, query = ""] = href.split("?");
	const params = query.split("&");
	const families = params.filter((p) => p.startsWith("family="));
	const rest = params.filter((p) => p && !p.startsWith("family="));
	return families.length < 2 ? [href] : families.map((family) => `${base}?${[family, ...rest].join("&")}`);
};

export default function FontStylesheet({ href }: { href: string }) {
	const links = perFamily(href).map((url) => `<link rel="stylesheet" href="${url.replace(/&/g, "&amp;").replace(/"/g, "&quot;")}">`);
	return <span hidden dangerouslySetInnerHTML={{ __html: links.join("") }} />;
}
